
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 8.667H8.666V12c0 .367-.3.667-.666.667A.669.669 0 017.333 12V8.667H4A.669.669 0 013.333 8c0-.367.3-.667.667-.667h3.333V4c0-.366.3-.667.667-.667.366 0 .666.3.666.667v3.333H12c.366 0 .666.3.666.667 0 .367-.3.667-.666.667z","fill":"#9D4B72"}})])
          )
        }
      }
    